import { apiConfig } from "core-lib/config/config";
import { getMethod } from "core-lib/utils/apiV2";

const SEO_BASE_URL = apiConfig('seoService');

export const getPlaceDetailsNonAuthenticated = async (placeId, serviceName) => {
  const url = `${apiConfig("infra")}/api/v4/infra/place/details/`
  const queryParams = {
    place_id: placeId,
    ...(serviceName ? {source: serviceName}: {})
  }
  const { response }: any = await getMethod({ endPoint: url, params: queryParams });
  if (response?.data?.place_id_details) {
    return response?.data?.place_id_details;
  }
  return null;
};

export const getPlaceDetails = async (placeId) => {
  const url = `${SEO_BASE_URL}/api/v1/place-details?placeId=${placeId}`;
  const { response }: any = await getMethod({ endPoint: url });
  if (response?.data) {
    return response?.data;
  }
  return null;
};
